// extracted by mini-css-extract-plugin
export default {"shipment-table__wrapper":"SalesOrderTable_shipment-table__wrapper__woGXG","shipment-table":"SalesOrderTable_shipment-table__VumlG"};